import React, { useState, useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";

import { useFilterGroup } from "@hooks/useFilterGroup";
import withNotification from "@hooks/useNotification";
import { useReduxSelector } from "@hooks/useReduxSelector";

import BackButton from "@components/tailwindComponents/BackButton";

import { fetchExportationData } from "./_config/exportation.utils";

import CheckableEmployeeList from "./CheckableEmployeeList";
import ExportDataSelection from "./ExportDataSelection";
import ExportFilterHeader from "./ExportFilterHeader";

function ExportList({ returnToEmployeList }) {
  const { t } = useTranslation("pages.employés.exportation");
  const filters = useMemo(
    () => ({
      Employer: [],
      emplacements: [],
      groups: [],
      statut: [],
      withoutNews: true
    }),
    []
  );

  const { isGroupIdsMatchFilter } = useFilterGroup();
  const [loading, setLoading] = useState(null);
  const [listEmploye, setListEmploye] = useState([]);
  const [filteredEmploye, setFilteredEmploye] = useState([]);

  const statutList = [
    { _id: 0, name: "Actif", originalName: "Actif", color: "arh-bg-[#92E890]" },
    {
      _id: 1,
      name: "Inactif Définitivement",
      originalName: "Inactif Définitivemen",
      color: "arh-bg-[#FD7D54]"
    }
  ];

  const statutListTranslated = useMemo(
    () =>
      statutList.map((option) => ({
        ...option,
        name: t(option.name),
        originalName: option.name,
        _id: option._id
      })),
    [t]
  );

  const [selectedEmploye, setSelectedEmploye] = useState([]);
  const [selectedEmplacement, setSelectedEmplacement] = useState([]);
  const [selectedGroupe, setSelectedGroupe] = useState([]);
  const [selectedStatut, setSelectedStatut] = useState([
    statutListTranslated[0]
  ]);
  const [employeSelected, setEmployeSelected] = useState([]);

  const { employers, emplacements, groupes } = useReduxSelector(
    (state) => state.commonData
  );

  useEffect(() => {
    applyFilter();
  }, []);

  const filterData = (data) => {
    if (
      !selectedEmploye?.length &&
      !selectedEmplacement?.length &&
      !selectedGroupe?.length &&
      !selectedStatut?.length
    ) {
      setFilteredEmploye(data);
      setLoading(false);
    } else {
      filters.Employer = selectedEmploye?.map((employe) => employe?._id);
      filters.emplacements = selectedEmplacement?.map((empl) => empl?._id);
      filters.groups = selectedGroupe;
      filters.statut = selectedStatut?.map((st) => st?.originalName);
      let employerFiltered = data;
      employerFiltered = employerFiltered.filter((employe) => {
        if (
          selectedEmploye?.length &&
          !filters.Employer.includes(employe?.emploiSalary?._id)
        ) {
          return false;
        }
        if (
          selectedEmplacement?.length &&
          !employe.emplacement.employeeEmplacement.some((emplacement) =>
            filters.emplacements.includes(emplacement._id)
          )
        ) {
          return false;
        }
        if (!isGroupIdsMatchFilter(employe, filters.groups)) {
          return false;
        }
        if (
          selectedStatut?.length &&
          !filters.statut.includes(employe.status)
        ) {
          return false;
        }
        return true;
      });
      setTimeout(() => {
        setFilteredEmploye(employerFiltered);
        setLoading(false);
      });
    }
  };

  const applyFilter = async () => {
    setLoading(true);
    if (listEmploye.length === 0) {
      const response = await fetchExportationData(JSON.stringify(filters));

      setListEmploye(response);
      filterData(response);
    } else {
      filterData(listEmploye);
    }
    setEmployeSelected([]);
  };

  const selectAllEmploye = () => {
    if (employeSelected?.length !== filteredEmploye.length) {
      setEmployeSelected(filteredEmploye);
    } else {
      setEmployeSelected([]);
    }
  };

  function selectEmploye(employe) {
    setEmployeSelected((prevState) => {
      if (prevState?.some((o) => o._id === employe._id)) {
        return prevState.filter((o) => o._id !== employe._id);
      } else {
        return [...prevState, employe];
      }
    });

    // if (employeSelected?.some((o) => o._id === employe._id)) {
    //   setEmployeSelected(employeSelected.filter((o) => o._id !== employe._id));
    // } else {
    //   setEmployeSelected([...employeSelected, employe]);
    // }
  }

  return (
    <div className="arh-relative arh-bg-white arh-p-4 arh-px-9">
      <div className="arh-mb-4">
        <BackButton onClick={returnToEmployeList} />
      </div>

      <ExportFilterHeader
        t={t}
        employers={employers}
        emplacements={emplacements}
        groupes={groupes}
        statutListTranslated={statutListTranslated}
        selectedEmploye={selectedEmploye}
        setSelectedEmploye={setSelectedEmploye}
        selectedEmplacement={selectedEmplacement}
        setSelectedEmplacement={setSelectedEmplacement}
        selectedGroupe={selectedGroupe}
        setSelectedGroupe={setSelectedGroupe}
        selectedStatut={selectedStatut}
        setSelectedStatut={setSelectedStatut}
        applyFilter={applyFilter}
      />

      <div className="arh-mt-8 arh-flex arh-items-start arh-space-x-11 arh-overflow-x-auto desktop-middle:arh-space-x-5">
        <CheckableEmployeeList
          t={t}
          loading={loading}
          filteredEmploye={filteredEmploye}
          employeSelected={employeSelected}
          selectAllEmploye={selectAllEmploye}
          selectEmploye={selectEmploye}
        />

        <ExportDataSelection employeSelected={employeSelected} />
      </div>
    </div>
  );
}

export default withNotification(ExportList);
